import React, { Component } from 'react'
import LoadMask from 'Utils/LoadMask/LoadMask';
import CardFormNoBorder from '../../../../Utils/Cards/CardFormNoBorder';
import Tabs, { TabPane } from 'rc-tabs';
import CostoVentasForm from './CostoVentasForm';

export default class CostoVentasReport extends Component {

    componentDidMount() {
        this.props.getDollar()
        this.props.getCostOfSales()
        this.props.getComparativoData()
    }
    componentDidUpdate(prevProps) {
        if (this.props.tab !== prevProps.tab) {
                this.props.getDollar();
                this.props.getCostOfSales();
                this.props.getComparativoData();
        }
    }
    actualizar = (data) => {
        const dataSave = {
            ...data,
            isDollar: this.props.currency === 'USD' ? true : false
        }
        this.props.editar(null, dataSave);
    };

    getPermissions = () => {
        const { getMe } = this.props;
        getMe();
    }

    render() {
        const { tab, setTab } = this.props;
        const { updateData, loader, item } = this.props;


        return (
            <div className="mb-4 col-12">
                <CardFormNoBorder
                    icon="Side_activos/finca.svg"
                    titulo="COSTO DE VENTAS"
                    subtitulo="RESUMEN"
                    subtituloForm={"VER"}
                    col="12"
                    noShadow
                >

                </CardFormNoBorder>
                <Tabs
                    defaultActiveKey={tab}
                    onChange={tab => setTab(tab)}
                    animated={{ tabPane: true, inkBar: true }}
                >
                    <TabPane tab='COSTO DE VENTAS' key="COSTO_DE_VENTAS">
                        <LoadMask loading={loader} blur>
                            <CostoVentasForm
                                onSubmit={this.actualizar}
                                updateData={updateData}
                                item={item}
                                editando={true}
                                {...this.props}
                            />
                        </LoadMask>
                    </TabPane>
                </Tabs>
            </div>
        )
    }
}

